// 午夜影院 · 首页静态展示数据（纯展示，不接接口）

export const navLinks = [
  { id: "latest", label: "最新电影", target: "#latest" },
  { id: "midnight", label: "午夜场", target: "#midnight" },
  { id: "uncut", label: "无删减版", target: "#uncut" },
  { id: "classic", label: "经典老片", target: "#classic" },
  { id: "collections", label: "深夜片单", target: "#collections" },
];

export const heroStats = [
  { id: "s1", value: "12,480", label: "在库片目" },
  { id: "s2", value: "960+", label: "午夜场次" },
  { id: "s3", value: "3,200", label: "无删减版" },
  { id: "s4", value: "24h", label: "深夜不打烊" },
];

export const filterGroups = [
  {
    id: "genre",
    title: "想看的类型",
    options: ["悬疑", "剧情", "犯罪", "惊悚", "经典老片", "爱情"],
  },
  {
    id: "slot",
    title: "观影片段",
    options: ["午夜场", "凌晨场", "通宵连看", "睡前一部"],
  },
  {
    id: "version",
    title: "版本偏好",
    options: ["无删减版", "导演剪辑", "加长版", "原始版"],
  },
];

export const hotKeywords = ["午夜场", "无删减版", "最新电影", "悬疑", "深夜电影", "经典老片", "在线观影"];

export const featuredPicks = [
  {
    id: "f1",
    rank: "01",
    title: "雾港来信",
    en: "Letters from Fog Harbor",
    year: "2026",
    genre: "悬疑 / 剧情",
    duration: "128 分钟",
    region: "华语",
    score: "8.7",
    summary: "一封迟到二十年的信，把海港小镇早已结案的旧事重新翻起，也翻出了一个不该被记住的名字。",
    poster:
      "https://readdy.ai/api/search-image?query=moody%20cinematic%20movie%20poster%20of%20a%20lone%20figure%20standing%20by%20a%20foggy%20harbor%20at%20night%2C%20deep%20charcoal%20background%20with%20warm%20amber%20streetlight%20glow%2C%20stylized%20film%20grain%2C%20dramatic%20low%20key%20lighting%2C%20minimal%20elegant%20composition&width=500&height=750&seq=midnight-poster-fog-01&orientation=portrait",
  },
  {
    id: "f2",
    rank: "02",
    title: "第七个夜班",
    en: "The Seventh Shift",
    year: "2026",
    genre: "惊悚 / 悬疑",
    duration: "112 分钟",
    region: "华语",
    score: "8.4",
    summary: "便利店监控里，凌晨三点总会多出一个不存在的人，而他只在第七个夜班出现。",
    poster:
      "https://readdy.ai/api/search-image?query=stylized%20cinematic%20movie%20poster%20of%20a%20small%20convenience%20store%20glowing%20at%20midnight%2C%20deep%20dark%20background%20with%20warm%20amber%20fluorescent%20light%2C%20lonely%20mood%2C%20film%20grain%2C%20high%20contrast%2C%20minimal%20dramatic%20composition&width=500&height=750&seq=midnight-poster-shift-02&orientation=portrait",
  },
  {
    id: "f3",
    rank: "03",
    title: "半岛之南",
    en: "South of the Peninsula",
    year: "2026",
    genre: "剧情 / 爱情",
    duration: "134 分钟",
    region: "华语",
    score: "8.1",
    summary: "两个陌生人在末班渡轮上交换了各自不敢说出口的秘密，然后各自回到岸上继续装作不认识。",
    poster:
      "https://readdy.ai/api/search-image?query=stylized%20cinematic%20movie%20poster%20of%20a%20ferry%20deck%20at%20night%20on%20calm%20dark%20water%2C%20warm%20amber%20lamp%20glow%2C%20deep%20charcoal%20background%2C%20quiet%20melancholy%20mood%2C%20film%20grain%2C%20minimal%20elegant%20composition&width=500&height=750&seq=midnight-poster-peninsula-03&orientation=portrait",
  },
  {
    id: "f4",
    rank: "04",
    title: "回声档案",
    en: "Echo Files",
    year: "2025",
    genre: "悬疑",
    duration: "106 分钟",
    region: "华语",
    score: "7.9",
    summary: "声音修复师在一段模糊的旧磁带底噪里，听见了自己的名字，而录音日期在他出生之前。",
    poster:
      "https://readdy.ai/api/search-image?query=stylized%20cinematic%20movie%20poster%20of%20vintage%20reel%20to%20reel%20tape%20recorder%20on%20a%20dark%20desk%2C%20warm%20amber%20desk%20lamp%20light%2C%20deep%20charcoal%20background%2C%20mysterious%20mood%2C%20film%20grain%2C%20minimal%20dramatic%20composition&width=500&height=750&seq=midnight-poster-echo-04&orientation=portrait",
  },
];

export const latestMovies = [
  {
    id: "l1",
    title: "雾港来信",
    en: "Letters from Fog Harbor",
    year: "2026",
    genre: "悬疑 / 剧情",
    duration: "128 分钟",
    region: "华语",
    score: "8.7",
    summary: "旧案卷宗里夹着一张没人认领的照片，寄信人却早在案发那年就搬离了海港。",
    tags: ["无删减版", "午夜场"],
  },
  {
    id: "l2",
    title: "第七个夜班",
    en: "The Seventh Shift",
    year: "2026",
    genre: "惊悚 / 悬疑",
    duration: "112 分钟",
    region: "华语",
    score: "8.4",
    summary: "他把每一班的值守都记在本子上，唯独第七页的字迹，不是他自己的。",
    tags: ["最新电影"],
  },
  {
    id: "l3",
    title: "半岛之南",
    en: "South of the Peninsula",
    year: "2026",
    genre: "剧情 / 爱情",
    duration: "134 分钟",
    region: "华语",
    score: "8.1",
    summary: "渡轮靠岸前的那十七分钟，成了两个人这一生最诚实的一段时间。",
    tags: ["剧情", "加长版"],
  },
  {
    id: "l4",
    title: "回声档案",
    en: "Echo Files",
    year: "2025",
    genre: "悬疑",
    duration: "106 分钟",
    region: "华语",
    score: "7.9",
    summary: "越是反复播放那段底噪，名字就越清晰，清晰得让人想立刻关掉机器。",
    tags: ["悬疑", "原始版"],
  },
  {
    id: "l5",
    title: "深水区",
    en: "The Deep End",
    year: "2025",
    genre: "犯罪 / 悬疑",
    duration: "119 分钟",
    region: "华语",
    score: "8.0",
    summary: "他打捞上来的不是沉船，而是一个被人刻意从记忆里抹掉的夜晚。",
    tags: ["犯罪", "导演剪辑"],
  },
  {
    id: "l6",
    title: "等一场雪",
    en: "Waiting for Snow",
    year: "2025",
    genre: "剧情",
    duration: "98 分钟",
    region: "华语",
    score: "7.6",
    summary: "北方小城那年的雪迟迟不来，像两个人之间那句一直没说完的话。",
    tags: ["剧情", "睡前一部"],
  },
  {
    id: "l7",
    title: "不眠剪辑室",
    en: "The Sleepless Edit",
    year: "2025",
    genre: "惊悚",
    duration: "103 分钟",
    region: "华语",
    score: "7.8",
    summary: "每剪出一版结局，现实里就少一个人，而剪辑师开始分不清哪一版是真的。",
    tags: ["惊悚", "未分级"],
  },
  {
    id: "l8",
    title: "末班地铁",
    en: "The Last Train",
    year: "2024",
    genre: "悬疑 / 剧情",
    duration: "95 分钟",
    region: "华语",
    score: "7.5",
    summary: "空荡的车厢里只有他和一个从不检票的乘务员，可线路图上并没有这一站。",
    tags: ["午夜场"],
  },
  {
    id: "l9",
    title: "银幕背面",
    en: "Behind the Screen",
    year: "2024",
    genre: "剧情",
    duration: "110 分钟",
    region: "华语",
    score: "8.2",
    summary: "老放映员守着城里最后一家影院，等一个说好要回来的观众。",
    tags: ["经典氛围", "剧情"],
  },
  {
    id: "l10",
    title: "雨夜出租车",
    en: "Rainy Night Cab",
    year: "2024",
    genre: "悬疑",
    duration: "101 分钟",
    region: "华语",
    score: "7.7",
    summary: "计价器每跳一次，后座的乘客就少说一句话，直到车里只剩雨声。",
    tags: ["悬疑", "午夜场"],
  },
];

export const midnightShows = [
  { id: "m1", time: "23:00", title: "暗室", genre: "悬疑", summary: "暗房药水显影出的，是一张谁都不认识的脸。", slot: "午夜场" },
  { id: "m2", time: "23:40", title: "旧胶片", genre: "剧情", summary: "一卷受潮的胶片，重映了一个被剪掉的夏天。", slot: "午夜场" },
  { id: "m3", time: "00:20", title: "无声来电", genre: "惊悚", summary: "电话那头始终没有声音，可他听得出是谁。", slot: "凌晨场" },
  { id: "m4", time: "01:00", title: "凌晨三点的信", genre: "剧情", summary: "写给自己的信，却署着别人的名字。", slot: "凌晨场" },
  { id: "m5", time: "01:50", title: "一个人的海", genre: "剧情", summary: "退潮以后，沙滩上只剩一串一个人回来的脚印。", slot: "通宵连看" },
  { id: "m6", time: "02:30", title: "夜巡者", genre: "犯罪", summary: "夜班巡逻的路线，和他记忆里的那条，每隔一周就会错开一次。", slot: "通宵连看" },
];

export const uncutMovies = [
  { id: "u1", title: "雾港来信 · 完整版", note: "比公映版多出 22 分钟关键线索", duration: "150 分钟", badge: "无删减版" },
  { id: "u2", title: "深水区 · 导演剪辑", note: "补齐结尾案件动机的完整交代", duration: "146 分钟", badge: "导演剪辑" },
  { id: "u3", title: "第七个夜班 · 未分级", note: "保留原始夜班监控段落", duration: "129 分钟", badge: "未分级" },
  { id: "u4", title: "不眠剪辑室 · 加长版", note: "收录被删掉的三版不同结局", duration: "138 分钟", badge: "加长版" },
  { id: "u5", title: "半岛之南 · 三小时版", note: "渡轮段落一镜到底完整呈现", duration: "182 分钟", badge: "加长版" },
  { id: "u6", title: "回声档案 · 原始版", note: "保留最早一版底噪素材", duration: "118 分钟", badge: "原始版" },
];

export const classicMovies = [
  { id: "c1", title: "午夜钟声", year: "1994", genre: "悬疑", summary: "每到午夜，钟楼就会多敲一下，多出来的那一下从来没人认领。" },
  { id: "c2", title: "雨人日记", year: "1989", genre: "剧情", summary: "一本被雨水泡皱的日记，记着一个人和自己相处的方式。" },
  { id: "c3", title: "车站", year: "1979", genre: "剧情", summary: "末班车开走以后，站台上留下的是所有没说完的话。" },
  { id: "c4", title: "长夜", year: "1983", genre: "犯罪", summary: "长夜里追一个案子的两个人，最后谁也没能等到天亮。" },
  { id: "c5", title: "灯下", year: "1991", genre: "剧情", summary: "深夜里还亮着的那盏灯，照着一个不肯睡的人。" },
  { id: "c6", title: "旧梦", year: "1987", genre: "爱情", summary: "多年以后重逢，他们发现记得最清楚的不是对方，而是那间旧放映厅。" },
];

export const collections = [
  {
    id: "col1",
    title: "一个人看的悬疑之夜",
    count: "18 部",
    desc: "不吵不闹，适合一个人戴着耳机慢慢往下看的悬疑片单。",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20dark%20cinematic%20scene%20of%20an%20empty%20seat%20in%20a%20dim%20theater%20with%20warm%20amber%20projector%20beam%2C%20deep%20charcoal%20tones%2C%20quiet%20mysterious%20mood%2C%20film%20grain%2C%20minimal%20composition&width=800&height=600&seq=midnight-collection-suspense-01&orientation=landscape",
  },
  {
    id: "col2",
    title: "凌晨三点，适合慢慢看的剧情",
    count: "24 部",
    desc: "节奏舒缓、情绪扎实的剧情片，配一杯温水刚好。",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20cozy%20dark%20room%20at%203am%20with%20a%20warm%20desk%20lamp%20and%20a%20cup%20of%20tea%2C%20deep%20charcoal%20background%2C%20calm%20melancholy%20mood%2C%20film%20grain%2C%20minimal%20elegant%20composition&width=800&height=600&seq=midnight-collection-drama-02&orientation=landscape",
  },
  {
    id: "col3",
    title: "无删减版·一次看个够",
    count: "31 部",
    desc: "完整版、导演剪辑、加长版集中收纳，不落下任何一个关键段落。",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20stack%20of%20vintage%20film%20canisters%20on%20a%20dark%20desk%20with%20warm%20amber%20light%2C%20deep%20charcoal%20background%2C%20cinematic%20mood%2C%20film%20grain%2C%20minimal%20composition&width=800&height=600&seq=midnight-collection-uncut-03&orientation=landscape",
  },
];

export const howToSteps = [
  { id: "h1", step: "01", title: "选类型或片段", desc: "用顶部筛选条勾选悬疑、剧情，或直接点「午夜场」，缩小范围。" },
  { id: "h2", step: "02", title: "看标题 + 短摘要", desc: "片单只给关键信息，标题和一句话摘要对味了再往下看。" },
  { id: "h3", step: "03", title: "从入口直接进入", desc: "每一条片目右侧都有醒目的观看入口，也可以先收藏进深夜片单。" },
];

export const footerGroups = [
  { id: "g1", title: "快速找片", links: ["最新电影", "午夜场", "无删减版", "经典老片"] },
  { id: "g2", title: "深夜片单", links: ["悬疑之夜", "凌晨剧情", "通宵连看", "一个人看"] },
  { id: "g3", title: "关于午夜影院", links: ["站点说明", "收录标准", "观影提示", "反馈建议"] },
];